import { FeedbackTableRenderer, type } from './DataTableArchivos';
import { FeedbackTableBSPRenderer, typeBSP } from './DataTableArchivosBSP';

class CustomFormFields {
  constructor(formFields) {
    formFields.register(type, FeedbackTableRenderer);
    formFields.register(typeBSP, FeedbackTableBSPRenderer);
  }
}


export default {
  __init__: [ 'feedbackButton' ],
  feedbackButton: [ 'type', CustomFormFields ]
};